import React, { useState, useEffect, useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./CropperProfilePhoto.scss";
import { Box, Button, Modal, Typography } from "@mui/material";

const CropperProfilePhoto = ({
  ImageURL,
  callBackImageCropped,
  callBackImageNotCropped,
}) => {
  const cropperRef = useRef(null);
  const [show, setShow] = useState(false);
  const [cropper, setCropper] = useState(null);

  const styleMod = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "600px",
    height: "500px",
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.27) 1.69%, #FFF 83.07%), linear-gradient(270deg, #F7FED5 9.62%, #CCFEFF 35.01%, #FDCFFE 70.05%, #F5EEDE 93.48%);box-shadow: 0px 0px 8px 2px rgba(111, 110, 110, 0.10)",
    // border: `3px solid ${values.chart[index].color}`,
    border: "none",
    borderRadius: "20px",
    boxShadow: 24,
    padding: "28px 56px",
    opacity: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    boxSizing: "unset",

    "&:focus-visible": {
      outline: "none",
    },
  };

  useEffect(() => {
    if (ImageURL) {
      setShow(true);
    }
  }, []);

  const handleCroppedImage = async () => {
    // if (cropper) {
    //   const file = await fetch(cropper.getCroppedCanvas().toDataURL())
    //     .then((res) => res.blob())
    //     .then((blob) => {
    //       return new File([blob], "newAvatar.png", { type: "image/png" });
    //     });
    //   if (file) {
    //     callBackImageCropped(file);
    //     handleClose();
    //   } else {
    //     handleClose();
    //   }
    // }

    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas();
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = croppedCanvas.width;
      canvas.height = croppedCanvas.height;

      ctx.fillStyle = "rgba(0,0,0,0)"; // Transparent background
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Draw a filled circle in the context
      ctx.beginPath();
      ctx.arc(
        canvas.width / 2,
        canvas.height / 2,
        canvas.width / 2,
        0,
        2 * Math.PI
      );
      ctx.clip();
      ctx.drawImage(croppedCanvas, 0, 0);

      // Convert the modified canvas to a blob
      canvas.toBlob(async (blob) => {
        const file = new File([blob], "newAvatar.png", { type: "image/png" });
        if (file) {
          callBackImageCropped(file);
          handleClose();
        } else {
          handleClose();
        }
      }, "image/png");
    }
  };

  const handleClose = () => {
    callBackImageNotCropped(null);
    setShow(false);
  };

  return (
    <>
      <Modal
        open={show}
        onClose={handleClose}
        BackdropProps={{
          style: {
            backgroundColor: "#F6F7F9",
            opacity: 0.8,
          },
        }}
      >
        <Box sx={styleMod}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: "#123051",
                fontSize: 22,
                fontFamily: "DM Sans",
                fontWeight: "500",
                marginBlock: 0,
              }}
            >
              Crop Image
            </Typography>
            <Typography
              sx={{
                color: "#123051",
                fontSize: 22,
                fontFamily: "DM Sans",
                fontWeight: "500",
                marginBlock: 0,
              }}
            >
              Preview
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              gap: "6px",
            }}
          >
            <Cropper
              src={ImageURL}
              style={{ height: 400, width: 400, margin: "auto" }}
              // initialAspectRatio={1 / 1}
              aspectRatio={1 / 1}
              viewMode={2}
              guides={true}
              background={false}
              responsive={true}
              checkOrientation={false}
              dragMode="move"
              toggleDragModeOnDblclick={true}
              cropBoxResizable={true}
              modal={false}
              rotatable={true}
              onInitialized={(instance) => {
                setCropper(instance);
              }}
              ref={cropperRef}
              preview=".img-preview"
            />

            <div className="box" style={{ width: "50%", float: "right" }}>
              {/* <h1>Preview</h1> */}
              <div
                className="img-preview"
                style={{ width: "100%", float: "left", height: 400 }}
              />
            </div>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "6px",
              marginTop: "10px",
            }}
          >
            <Button
              variant="outlined"
              sx={{
                textAlign: "center",
                color: "#565556",
                fontSize: "12px",
                fontFamily: "DM Sans",
                fontWeight: "400",
                wordWrap: "break-word",
                padding: "8px 30px",
                background: "#F6F7F9",
                borderRadius: "20px",
                overflow: "hidden",
                border: "1px solid #123051",

                "&:hover": {
                  background: "#c63213",
                  color: "white",
                },
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{
                textAlign: "center",
                color: "#FFFFFF",
                fontSize: "12px",
                fontFamily: "DM Sans",
                fontWeight: "400",
                wordWrap: "break-word",
                padding: "8px 30px",
                background: "#123051",
                borderRadius: "20px",
                overflow: "hidden",

                "&:hover": {
                  background: "#12c646",
                },
              }}
              onClick={handleCroppedImage}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CropperProfilePhoto;
